import React, {useState} from "react";
import {Box} from "@mui/system";
import styles from "../../organizationMainStyles";
import {Switch} from "@mui/material";
import {useDispatch} from "react-redux";
import _ from "lodash";
import {organizationSettingsActions} from "_actions";
import {accessibilityMode} from "../organizationSettingsConstants";
import {buildPresaleRemainderPayload} from "../organizationSettingsUtils";
import {SnackBar} from "../../../../../common";
import InformationTooltip from "../InformationTooltip";

export default function PresaleRemainderToggleContainer({mode, organization, label}) {
    const disable = mode === accessibilityMode.READ_ONLY;
    const isPresaleRemainderEnabled = _.get(organization, 'presaleRemainder');
    const [isPresaleRemainder, setIsPresaleRemainder] = useState(isPresaleRemainderEnabled);
    const organizationId = _.get(organization, 'id');
    const dispatch = useDispatch();

    const handleToggle = (event) => {
        const value = _.get(event, 'target.checked');
        setIsPresaleRemainder(value);
        handleUpdate(value);
    }

    const handleUpdate = (value) => {
        const payload = buildPresaleRemainderPayload(value);
        if (!organizationId || !payload) return SnackBar.showMessage('Invalid parameters');
        dispatch(organizationSettingsActions.updateOrganizationAttribute(organizationId, payload));
    }

    return(
        <Box sx={styles.notificationToggleContainer}>
            <Box component={'h2'} sx={styles.notificationToggleLabel}>
                {label.PRESALE_REMAINDER}
                <InformationTooltip label={"Automatically create or update an existing Proactive Presale campaign every month."}/>
            </Box>
            <Box>
                <Switch disabled={disable} checked={isPresaleRemainder} onChange={handleToggle} sx={styles.switch} />
            </Box>
        </Box>
    )
}